import { Outlet } from 'react-router-dom';
import Header from './Header';
import GlobalFloatingTimer from '../timer/GlobalFloatingTimer';
import styles from './AppLayout.module.css';

interface Props {
  subtitle?: string;
}

export default function AppLayout({ subtitle }: Props) {
  return (
    <div className={styles.layout}>
      <Header subtitle={subtitle} />
      <GlobalFloatingTimer />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
